// smithy-typescript generated code
import { Apiv2ServiceException as __BaseException } from "./Apiv2ServiceException";
/**
 * @public
 */
export var AutoTestPublishedSnapshotId;
(function (AutoTestPublishedSnapshotId) {
    AutoTestPublishedSnapshotId.visit = (value, visitor) => {
        if (value.unpublished !== undefined)
            return visitor.unpublished(value.unpublished);
        if (value.published !== undefined)
            return visitor.published(value.published);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestPublishedSnapshotId || (AutoTestPublishedSnapshotId = {}));
/**
 * @public
 * @enum
 */
export const AutoTestInstallClangVersion = {
    V_12: "12",
    V_16: "16",
};
/**
 * @public
 * @enum
 */
export const AutoTestInstallDotnetVersion = {
    V_6_0: "6.0",
    V_7_0: "7.0",
    V_8_0: "8.0",
    V_9_0: "9.0",
};
/**
 * @public
 * @enum
 */
export const AutoTestInstallGccVersion = {
    V_10: "10",
    V_13: "13",
    V_9: "9",
};
/**
 * @public
 * @enum
 */
export const AutoTestInstallJavaVersion = {
    V_11: "11",
    V_17: "17",
    V_21: "21",
    V_8: "8",
};
/**
 * @public
 * @enum
 */
export const AutoTestInstallNodeVersion = {
    V_14: "14",
    V_16: "16",
    V_18: "18",
};
/**
 * @public
 * @enum
 */
export const AutoTestInstallPythonVersion = {
    V_3_10: "3.10",
    V_3_11: "3.11",
    V_3_12: "3.12",
    V_3_13: "3.13",
    V_PYPY3_10_7_3_12: "pypy3.10 - 7.3.12",
};
/**
 * @public
 * @enum
 */
export const AutoTestDescriptionBehavior = {
    COLLAPSE: "collapse",
    UNCOLLAPSE: "uncollapse",
    UNCOLLAPSE_ON_FAIL: "uncollapse-on-fail",
};
/**
 * @public
 */
export var AutoTestSetupStepOutput;
(function (AutoTestSetupStepOutput) {
    AutoTestSetupStepOutput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepOutput || (AutoTestSetupStepOutput = {}));
/**
 * @public
 * @enum
 */
export const AutoTestCodeStructureTestVersion = {
    V_1_132_0: "1.132.0",
    V_1_43_0: "1.43.0",
};
/**
 * @public
 * @enum
 */
export const AutoTestFlake8Version = {
    V_6_0_0: "6.0.0",
};
/**
 * @public
 * @enum
 */
export const AutoTestJupyterNotebookKernel = {
    PYTHON_3: "Python 3",
};
/**
 * @public
 * @enum
 */
export const AutoTestJupyterNotebookPython3KernelVersion = {
    V_6_29_5: "6.29.5",
};
/**
 * @public
 * @enum
 */
export const AutoTestPytestVersion = {
    V_7_3_1: "7.3.1",
    V_7_4_4: "7.4.4",
    V_8_3_3: "8.3.3",
};
/**
 * @public
 */
export var AutoTestAutoInstallStepOutput;
(function (AutoTestAutoInstallStepOutput) {
    AutoTestAutoInstallStepOutput.visit = (value, visitor) => {
        if (value.autoInstallFlake8 !== undefined)
            return visitor.autoInstallFlake8(value.autoInstallFlake8);
        if (value.autoInstallPytest !== undefined)
            return visitor.autoInstallPytest(value.autoInstallPytest);
        if (value.autoInstallCodeStructureTest !== undefined)
            return visitor.autoInstallCodeStructureTest(value.autoInstallCodeStructureTest);
        if (value.autoInstallSimplePythonTest !== undefined)
            return visitor.autoInstallSimplePythonTest(value.autoInstallSimplePythonTest);
        if (value.autoInstallJupyterNotebook !== undefined)
            return visitor.autoInstallJupyterNotebook(value.autoInstallJupyterNotebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestAutoInstallStepOutput || (AutoTestAutoInstallStepOutput = {}));
/**
 * @public
 * @enum
 */
export const AutoTestSnapshotBuildProgramState = {
    /**
     * The program has crashed.
     */
    ERRORED: "errored",
    /**
     * The program has finished successfully, the snapshot can be
     * published.
     */
    FINISHED: "finished",
    /**
     * The program is currently running.
     */
    RUNNING: "running",
    /**
     * The program has not started yet.
     */
    WAITING_TO_START: "waiting-to-start",
};
/**
 * @public
 */
export var AutoTestSnapshotSource;
(function (AutoTestSnapshotSource) {
    AutoTestSnapshotSource.visit = (value, visitor) => {
        if (value.ran !== undefined)
            return visitor.ran(value.ran);
        if (value.copied !== undefined)
            return visitor.copied(value.copied);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSnapshotSource || (AutoTestSnapshotSource = {}));
/**
 * @public
 * @enum
 */
export const AutoTestCheckstyleVersion = {
    V_10_12_3: "10.12.3",
    V_9_3: "9.3",
};
/**
 * @public
 * @enum
 */
export const AutoTestJunit5Version = {
    V_1_10_0: "1.10.0",
    V_1_8_2: "1.8.2",
};
/**
 * @public
 * @enum
 */
export const AutoTestJupyterNotebookRunPermission = {
    DISABLED: "disabled",
    ENABLED: "enabled",
};
/**
 * @public
 * @enum
 */
export const AutoTestQuizAnswerOrder = {
    INDEX_ORDER: "index-order",
    RANDOM_ORDER: "random-order",
};
/**
 * @public
 * @enum
 */
export const AutoTestCaseSensitivity = {
    INSENSITIVE: "insensitive",
    SENSITIVE: "sensitive",
};
/**
 * @public
 * @enum
 */
export const AutoTestWhitespacesPolicy = {
    IGNORE: "ignore",
    INCLUDE: "include",
};
/**
 * @public
 * @enum
 */
export const AutoTestRunIfConditionType = {
    RUBRIC_PERCENTAGE_MET: "rubric-percentage-met",
    RUBRIC_PERCENTAGE_NOT_MET: "rubric-percentage-not-met",
};
/**
 * @public
 * @enum
 */
export const AutoTestRunInEnvironment = {
    AUTO_TEST: "auto-test",
    CODE_EDITOR: "code-editor",
    EVERYWHERE: "everywhere",
};
/**
 * @public
 * @enum
 */
export const AutoTestRunInNotebookInsertMethod = {
    AFTER_CELL: "after-cell",
    APPEND_TO_NOTEBOOK: "append-to-notebook",
    BEFORE_CELL: "before-cell",
    PREPEND_TO_NOTEBOOK: "prepend-to-notebook",
};
/**
 * @public
 * @enum
 */
export const AutoTestTestHideHideType = {
    CONFIG: "config",
    OUTPUT: "output",
    RESULT: "result",
};
/**
 * @public
 * @enum
 */
export const AutoTestTestHidePreposition = {
    AFTER: "after",
    ALWAYS: "always",
    BEFORE: "before",
};
/**
 * @public
 * @enum
 */
export const AutoTestTestHideWhen = {
    DEADLINE: "deadline",
    LOCKDATE: "lockdate",
};
/**
 * @public
 */
export var BadRequestErrorReason;
(function (BadRequestErrorReason) {
    BadRequestErrorReason.visit = (value, visitor) => {
        if (value.wrongItemCount !== undefined)
            return visitor.wrongItemCount(value.wrongItemCount);
        if (value.unknownEnumType !== undefined)
            return visitor.unknownEnumType(value.unknownEnumType);
        if (value.invalidState !== undefined)
            return visitor.invalidState(value.invalidState);
        if (value.invalidParam !== undefined)
            return visitor.invalidParam(value.invalidParam);
        if (value.inexplicitRubricOverwrite !== undefined)
            return visitor.inexplicitRubricOverwrite(value.inexplicitRubricOverwrite);
        if (value.ignoreNonInteractedQuestions !== undefined)
            return visitor.ignoreNonInteractedQuestions(value.ignoreNonInteractedQuestions);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(BadRequestErrorReason || (BadRequestErrorReason = {}));
/**
 * An error at the fault of the client sending invalid input.
 * @public
 */
export class BadRequestError extends __BaseException {
    name = "BadRequestError";
    $fault = "client";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * The underlying reason for this bad request.
     * @public
     */
    reason;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "BadRequestError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.reason = opts.reason;
    }
}
/**
 * An internal failure at the fault of the server.
 * @public
 */
export class InternalServerError extends __BaseException {
    name = "InternalServerError";
    $fault = "server";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
/**
 * An error due to the client not being authenticated.
 * @public
 */
export class NotAuthenticatedError extends __BaseException {
    name = "NotAuthenticatedError";
    $fault = "client";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "NotAuthenticatedError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
/**
 * An error due to the client not being authorized to access the
 * resource.
 * @public
 */
export class NotAuthorizedError extends __BaseException {
    name = "NotAuthorizedError";
    $fault = "client";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * The resource you are not authorized to access.
     * @public
     */
    resource;
    /**
     * The action or operation on `resource` that w were trying to
     * do but don't have authorization to do.
     * @public
     */
    operation;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "NotAuthorizedError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotAuthorizedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
        this.operation = opts.operation;
    }
}
/**
 * An error due to the client attempting to access a missing
 * resource.
 * @public
 */
export class NotFoundError extends __BaseException {
    name = "NotFoundError";
    $fault = "client";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * The resource that could not be found.
     * @public
     */
    resource;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "NotFoundError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
    }
}
/**
 * A standard error for input validation failures.
 * This should be thrown by services when a member of the input structure
 * falls outside of the modeled or documented constraints.
 * @public
 */
export class ValidationError extends __BaseException {
    name = "ValidationError";
    $fault = "client";
    /**
     * A technical description of the error.
     * @public
     */
    description;
    /**
     * The id of the request that generated the failure.
     * @public
     */
    requestId;
    /**
     * A list of specific failures encountered while validating the input.
     * A member can appear in this list more than once if it failed to satisfy multiple constraints.
     * @public
     */
    fieldList;
    /**
     * @internal
     */
    constructor(opts) {
        super({
            name: "ValidationError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.fieldList = opts.fieldList;
    }
}
/**
 * @public
 */
export var AutoTestOverwriteRubric;
(function (AutoTestOverwriteRubric) {
    AutoTestOverwriteRubric.visit = (value, visitor) => {
        if (value.doOverwrite !== undefined)
            return visitor.doOverwrite(value.doOverwrite);
        if (value.doNotOverwrite !== undefined)
            return visitor.doNotOverwrite(value.doNotOverwrite);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestOverwriteRubric || (AutoTestOverwriteRubric = {}));
/**
 * @public
 */
export var AutoTestRedactedString;
(function (AutoTestRedactedString) {
    AutoTestRedactedString.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedString || (AutoTestRedactedString = {}));
/**
 * @public
 */
export var AutoTestRedactedDeductions;
(function (AutoTestRedactedDeductions) {
    AutoTestRedactedDeductions.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedDeductions || (AutoTestRedactedDeductions = {}));
/**
 * @public
 */
export var AutoTestRedactedCheckstyleVersion;
(function (AutoTestRedactedCheckstyleVersion) {
    AutoTestRedactedCheckstyleVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCheckstyleVersion || (AutoTestRedactedCheckstyleVersion = {}));
/**
 * @public
 */
export var AutoTestRedactedCodeStructureTestVersion;
(function (AutoTestRedactedCodeStructureTestVersion) {
    AutoTestRedactedCodeStructureTestVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCodeStructureTestVersion || (AutoTestRedactedCodeStructureTestVersion = {}));
/**
 * @public
 */
export var AutoTestRedactedInteger;
(function (AutoTestRedactedInteger) {
    AutoTestRedactedInteger.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedInteger || (AutoTestRedactedInteger = {}));
/**
 * @public
 */
export var AutoTestRedactedFlake8Version;
(function (AutoTestRedactedFlake8Version) {
    AutoTestRedactedFlake8Version.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFlake8Version || (AutoTestRedactedFlake8Version = {}));
/**
 * @public
 */
export var AutoTestRedactedJunit5TestFile;
(function (AutoTestRedactedJunit5TestFile) {
    AutoTestRedactedJunit5TestFile.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedJunit5TestFile || (AutoTestRedactedJunit5TestFile = {}));
/**
 * @public
 */
export var AutoTestRedactedCaseSensitivity;
(function (AutoTestRedactedCaseSensitivity) {
    AutoTestRedactedCaseSensitivity.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCaseSensitivity || (AutoTestRedactedCaseSensitivity = {}));
/**
 * @public
 */
export var AutoTestRedactedWhitespacesPolicy;
(function (AutoTestRedactedWhitespacesPolicy) {
    AutoTestRedactedWhitespacesPolicy.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedWhitespacesPolicy || (AutoTestRedactedWhitespacesPolicy = {}));
/**
 * @public
 */
export var AutoTestRedactedRunIfCondition;
(function (AutoTestRedactedRunIfCondition) {
    AutoTestRedactedRunIfCondition.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunIfCondition || (AutoTestRedactedRunIfCondition = {}));
/**
 * @public
 */
export var AutoTestRedactedRunInNotebookInsertMethod;
(function (AutoTestRedactedRunInNotebookInsertMethod) {
    AutoTestRedactedRunInNotebookInsertMethod.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunInNotebookInsertMethod || (AutoTestRedactedRunInNotebookInsertMethod = {}));
/**
 * @public
 */
export var AutoTestRedactedSelectAllQuestionAnswersValueHints;
(function (AutoTestRedactedSelectAllQuestionAnswersValueHints) {
    AutoTestRedactedSelectAllQuestionAnswersValueHints.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedSelectAllQuestionAnswersValueHints || (AutoTestRedactedSelectAllQuestionAnswersValueHints = {}));
/**
 * @public
 */
export var AutoTestRedactedBoolean;
(function (AutoTestRedactedBoolean) {
    AutoTestRedactedBoolean.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedBoolean || (AutoTestRedactedBoolean = {}));
/**
 * @public
 */
export var AutoTestRedactedPositiveDuration;
(function (AutoTestRedactedPositiveDuration) {
    AutoTestRedactedPositiveDuration.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedPositiveDuration || (AutoTestRedactedPositiveDuration = {}));
/**
 * @public
 */
export var AutoTestRedactedUploadedFilesOutput;
(function (AutoTestRedactedUploadedFilesOutput) {
    AutoTestRedactedUploadedFilesOutput.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedUploadedFilesOutput || (AutoTestRedactedUploadedFilesOutput = {}));
/**
 * @public
 */
export var AutoTestRedactedFraction;
(function (AutoTestRedactedFraction) {
    AutoTestRedactedFraction.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFraction || (AutoTestRedactedFraction = {}));
/**
 * @public
 */
export var AutoTestSetupStepInput;
(function (AutoTestSetupStepInput) {
    AutoTestSetupStepInput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepInput || (AutoTestSetupStepInput = {}));
/**
 * @public
 */
export var AssistantMessageAssistantContent;
(function (AssistantMessageAssistantContent) {
    AssistantMessageAssistantContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageAssistantContent || (AssistantMessageAssistantContent = {}));
/**
 * @public
 */
export var AssistantMessageStopReason;
(function (AssistantMessageStopReason) {
    AssistantMessageStopReason.visit = (value, visitor) => {
        if (value.endTurn !== undefined)
            return visitor.endTurn(value.endTurn);
        if (value.maxTokens !== undefined)
            return visitor.maxTokens(value.maxTokens);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageStopReason || (AssistantMessageStopReason = {}));
/**
 * @public
 */
export var User;
(function (User) {
    User.visit = (value, visitor) => {
        if (value.group !== undefined)
            return visitor.group(value.group);
        if (value.normal !== undefined)
            return visitor.normal(value.normal);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(User || (User = {}));
/**
 * @public
 */
export var AssistantMessageUserContent;
(function (AssistantMessageUserContent) {
    AssistantMessageUserContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageUserContent || (AssistantMessageUserContent = {}));
/**
 * @public
 */
export var AssistantMessageData;
(function (AssistantMessageData) {
    AssistantMessageData.visit = (value, visitor) => {
        if (value.user !== undefined)
            return visitor.user(value.user);
        if (value.assistant !== undefined)
            return visitor.assistant(value.assistant);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageData || (AssistantMessageData = {}));
/**
 * @public
 */
export var AssistantData;
(function (AssistantData) {
    AssistantData.visit = (value, visitor) => {
        if (value.assignment !== undefined)
            return visitor.assignment(value.assignment);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantData || (AssistantData = {}));
/**
 * @public
 * @enum
 */
export const AssistantFeature = {
    ACCESS_TO_PAGE: "ACCESS_TO_PAGE",
};
/**
 * @public
 */
export var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus.visit = (value, visitor) => {
        if (value.enabled !== undefined)
            return visitor.enabled(value.enabled);
        if (value.disabled !== undefined)
            return visitor.disabled(value.disabled);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantStatus || (AssistantStatus = {}));
/**
 * @public
 */
export var JupyterKernelStatus;
(function (JupyterKernelStatus) {
    JupyterKernelStatus.visit = (value, visitor) => {
        if (value.alive !== undefined)
            return visitor.alive(value.alive);
        if (value.dead !== undefined)
            return visitor.dead(value.dead);
        if (value.starting !== undefined)
            return visitor.starting(value.starting);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterKernelStatus || (JupyterKernelStatus = {}));
/**
 * @public
 */
export var JupyterMimeOutputDataEventValue;
(function (JupyterMimeOutputDataEventValue) {
    JupyterMimeOutputDataEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterMimeOutputDataEventValue || (JupyterMimeOutputDataEventValue = {}));
/**
 * @public
 */
export var JupyterStreamOutputEventValue;
(function (JupyterStreamOutputEventValue) {
    JupyterStreamOutputEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterStreamOutputEventValue || (JupyterStreamOutputEventValue = {}));
/**
 * @public
 */
export var JupyterOutputEvent;
(function (JupyterOutputEvent) {
    JupyterOutputEvent.visit = (value, visitor) => {
        if (value.executeStart !== undefined)
            return visitor.executeStart(value.executeStart);
        if (value.stream !== undefined)
            return visitor.stream(value.stream);
        if (value.displayData !== undefined)
            return visitor.displayData(value.displayData);
        if (value.executeResult !== undefined)
            return visitor.executeResult(value.executeResult);
        if (value.error !== undefined)
            return visitor.error(value.error);
        if (value.executeRequested !== undefined)
            return visitor.executeRequested(value.executeRequested);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterOutputEvent || (JupyterOutputEvent = {}));
/**
 * @public
 */
export var EditorSessionSource;
(function (EditorSessionSource) {
    EditorSessionSource.visit = (value, visitor) => {
        if (value.template !== undefined)
            return visitor.template(value.template);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EditorSessionSource || (EditorSessionSource = {}));
/**
 * @public
 */
export var OuptutRegularFileType;
(function (OuptutRegularFileType) {
    OuptutRegularFileType.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        if (value.binary !== undefined)
            return visitor.binary(value.binary);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.notebook !== undefined)
            return visitor.notebook(value.notebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OuptutRegularFileType || (OuptutRegularFileType = {}));
/**
 * @public
 */
export var InputFileType;
(function (InputFileType) {
    InputFileType.visit = (value, visitor) => {
        if (value.directory !== undefined)
            return visitor.directory(value.directory);
        if (value.regular !== undefined)
            return visitor.regular(value.regular);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(InputFileType || (InputFileType = {}));
/**
 * @public
 */
export var SafeProgramSource;
(function (SafeProgramSource) {
    SafeProgramSource.visit = (value, visitor) => {
        if (value.pearsonQuestion !== undefined)
            return visitor.pearsonQuestion(value.pearsonQuestion);
        if (value.singleQuizQuestion !== undefined)
            return visitor.singleQuizQuestion(value.singleQuizQuestion);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(SafeProgramSource || (SafeProgramSource = {}));
/**
 * @public
 */
export var NumberOfAttempts;
(function (NumberOfAttempts) {
    NumberOfAttempts.visit = (value, visitor) => {
        if (value.unlimited !== undefined)
            return visitor.unlimited(value.unlimited);
        if (value.limited !== undefined)
            return visitor.limited(value.limited);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(NumberOfAttempts || (NumberOfAttempts = {}));
/**
 * @public
 * @enum
 */
export const PearsonMultipleChoiceQuestionAnswerOrder = {
    /**
     * Order answers by their index in the ATv2 configuration.
     */
    INDEX_ORDER: "index-order",
    /**
     * Order answers randomly.
     */
    RANDOM_ORDER: "random-order",
};
/**
 * @public
 * @enum
 */
export const PearsonSelectAllQuestionAnswerOrder = {
    /**
     * Order answers by their index in the ATv2 configuration.
     */
    INDEX_ORDER: "index-order",
    /**
     * Order answers randomly.
     */
    RANDOM_ORDER: "random-order",
};
/**
 * @public
 */
export var PearsonQuestionData;
(function (PearsonQuestionData) {
    PearsonQuestionData.visit = (value, visitor) => {
        if (value.coding !== undefined)
            return visitor.coding(value.coding);
        if (value.multipleChoice !== undefined)
            return visitor.multipleChoice(value.multipleChoice);
        if (value.selectAll !== undefined)
            return visitor.selectAll(value.selectAll);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PearsonQuestionData || (PearsonQuestionData = {}));
